import config from 'config';

const FULL_URL_REGEXP = new RegExp('^(https?:)?//.*');

/**
 * @param url {String}
 * @returns {boolean}
 */
export function isFullUrl(url) {
  return FULL_URL_REGEXP.test(url);
}

// TODO in webshop code this is loaded from server config properties, here we would have to
// probably do the same or somehow set the Express.js request as a globally accessible variable,
// as using fixed value cause react to claim that server-side rendered content differ from the
// client-side one
const SERVER_HOST = config.domain;
const SERVER_URL_REGEXP = config.isServer
  ? new RegExp(`^((https?:)?//${SERVER_HOST}).*`)
  : new RegExp(`^((https?:)?//((${SERVER_HOST})|(${window.location.host}))+).*`);

/**
 * @param url {String}
 * @returns {boolean}
 */
export function isInternalUrl(url) {
  return url ? (!isFullUrl(url) || SERVER_URL_REGEXP.test(url)) : false;
}

/**
 * @param url {String}
 * @returns {boolean}
 */
export function isExternalUrl(url) {
  return url ? (!isInternalUrl(url)) : false;
}

/**
 * @param event {MouseEvent}
 * @param customTarget=false {Node|false} Use custom target, otherwise use event.currentTarget || event.target
 * @returns {boolean}
 */
export function shouldHandleClickEventInternally(event, customTarget = false) {
  const isEventWithModifierKeys = Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

  if (isEventWithModifierKeys) {
    return false; // modifier keys usually means user wants to open the link in new window/tab
  }

  const leftClickEvent = event.button === 0;
  if (!leftClickEvent) {
    return false; // some browsers may send the 'click' event for the right mouse button, ignore
  }

  const eventTarget = customTarget || event.currentTarget || event.target;
  const { target, href } = eventTarget;

  if (target && target !== '_self') {
    return false; // target prop is set to e.g. to "_blank", should always open in a new window/tab
  }

  return isInternalUrl(href);
}
